export const MAP_LAYERS_TEMPLATE = {
  op: 'ui',
  name: 'LayerMenu',
  baseLayers: [
    {
      type: 'classic',
      label: 'common:component.map.layers.labels.classic',
      flag: 'portals-classic-map-layer',
      testId: 'layer-select-classic',
    },
    {
      type: 'parcel-boundaries',
      label: 'common:component.map.layers.labels.parcel-boundaries',
      flag: 'portals-parcel-boundaries-map-layer',
      testId: 'layer-select-parcel',
    },
    {
      type: 'satellite',
      label: 'common:component.map.layers.labels.satellite',
      flag: 'portals-satellite-map-layer',
      testId: 'layer-select-satellite',
    },
  ],
  detailLayers: [
    {
      type: 'things',
      label: 'common:terms:thing_other',
      flag: 'portals-things-map-layer',
      testId: 'layer-select-things',
    },
    {
      type: 'traffic',
      label: 'common:component.map.layers.labels.traffic',
      flag: 'portals-traffic-map-layer',
      testId: 'layer-select-traffic',
      minZoomLevel: 6.5,
    },
    {
      type: 'transport',
      label: 'common:component.map.layers.labels.transport',
      flag: 'portals-transport-map-layer',
      testId: 'layer-select-transport',
      minZoomLevel: 7.5,
    },
    {
      type: 'incidents',
      label: 'common:component.map.layers.labels.incidents',
      flag: 'portals-incidents-map-layer',
      testId: 'layer-select-incidents',
      maxBoundingBoxSize: 1,
    },
  ],
  entityLayers: [
    {
      type: 'geofences',
      label: 'common:terms:geofence_other',
      flag: 'portals-geofences-map-layer',
      testId: 'layer-select-geofences',
      showSubMenuButton: true,
    },
    {
      type: 'point-of-interest',
      label: 'common:component.map.layers.labels.point-of-interest',
      flag: 'track-point-of-interest-feature',
      testId: 'layer-select-point-of-interest',
      showSubMenuButton: true,
    },
  ],
};
